import { node } from 'prop-types';
import * as React from 'react';
import Shelf from '../Shelf/index';

const ButtonGroup = ({ children, ...rest }) => {
  return (
    <Shelf gap="xsmall" {...rest}>
      {children}
    </Shelf>
  );
};

ButtonGroup.propTypes = {
  children: node.isRequired,
};

export default ButtonGroup;
